/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateEmploymentPasscodeRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateEmploymentPasscodeResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateEmploymentPasscode = (request: UpdateEmploymentPasscodeRequest, options?: CashRequestOptions) => post<UpdateEmploymentPasscodeRequest, UpdateEmploymentPasscodeResponse>("/2.0/cash/update-employment-passcode", request, {...options, rejectOnError: true })